import { render } from "./TransformToolsButton.vue?vue&type=template&id=4ee15019&scoped=true"
import script from "./TransformToolsButton.vue?vue&type=script&lang=js"
export * from "./TransformToolsButton.vue?vue&type=script&lang=js"

import "./TransformToolsButton.vue?vue&type=style&index=0&id=4ee15019&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee15019"]])

export default __exports__